import React from 'react';
import {
  NoInternet,
  Page500,
  SysMaintain,
} from '@pages';
import { PRIVATE_ROUTE } from './route.constants';
import { connect } from 'react-redux';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      isOnline: true,
    };
  }

  componentDidMount() {
    window.addEventListener('online', () => {
      if (window.location.pathname !== `/${PRIVATE_ROUTE.IN_GAME}`) {
        window.location.reload();
      }
    });

    window.addEventListener('offline', () => {
      if (window.location.pathname !== `/${PRIVATE_ROUTE.IN_GAME}`) {
        this.setState({ isOnline: false });
      }
    });
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {

    if (this.props.is_maintained) {
      return <SysMaintain />;
    }

    if (this.state.hasError) {
      return <Page500 />;
    }

    if (!navigator.onLine || !this.state.isOnline) {
      return <NoInternet />;
    }

    return this.props.children;
  }
}

const mapStateToProps = (state) => {
  const { is_maintained } = state.app;

  return {
    is_maintained,
  };
};

export default connect(mapStateToProps)(ErrorBoundary);
